import React, { Component } from 'react';
import {  DropdownItem, DropdownMenu, DropdownToggle, Nav } from 'reactstrap';
import PropTypes from 'prop-types';

import {  AppHeaderDropdown,AppSidebarToggler} from '@coreui/react';
import {Button,Icon} from 'semantic-ui-react'
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import visitortag_logo from '../../assets/img/logos/visitor_logo.png';
import parktag_logo from '../../assets/img/logos/parktag_logo.png';
import tag_logo from  '../../assets/img/logos/tag_logo.svg';
import event_logo from  '../../assets/img/logos/event_logo_without_shadow.png';
import md_logo from  '../../assets/img/logos/md-logo.png';
import * as common from "../../const/Common/CommonFunc";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class CorporateHeader extends Component {

  state = {
    select_tag:1,
    park_service: false,
    visitor_service: false,
    space_service: false,
    event_service: false,
  };
  componentDidMount(){
    let services = this.props.usr_obj.services;

    if(services.length !== 0){
      services.map((service,index)=>{
        if(service.serviceId === 1){
          this.setState({
            park_service: true
          })
        }
        if(service.serviceId === 2){
          this.setState({
            visitor_service: true
          })
        }
        if(service.serviceId === 4){
          this.setState({
            event_service: true
          })
        }
        if(service.serviceId === 5){
          this.setState({
            space_service: true
          })
        }
      });
    }
  }
  checkSystem(type) {
    if (type === 5)
      this.props.history.push('/corporate/spacetags/workspace');
    if (type === 4)
      this.props.history.push('/corporate/eventtags/dashboard');
    if (type === 2)
      this.props.history.push('/corporate/visitorTag/dashboard');
    if (type === 1)
      this.props.history.push('/corporate/dashboard');
  }

  changeSystem = (type) => {
    if(type === 2){
      let {branchCount,departmentCount,buildingsCount} = this.props;
      // let isActiveVisitor = !(branchCount === 0 || departmentCount === 0 || buildingsCount === 0);
      let isActiveVisitor = !(branchCount === 0 || buildingsCount === 0);
      if(!isActiveVisitor){
        // common.notifyMessage("First, Please create one or more Branches / Departments and Buildings",4);
        common.notifyMessage("First, Please create one or more Branches and Buildings",4);
        return;
      }
    }
    this.checkSystem(type);
    this.props.systemChangeHandler(type)
  };

  render() {
    return (
      <React.Fragment>
        <AppSidebarToggler className="d-lg-none" display="md" mobile />
        <h1 className={"logo-text"}>
          {/*<span style={{color:'#53bd52'}}>#</span>tags*/}
          <img src={md_logo} alt={"."} className={"logo-main"}/>
        </h1>

        <Button animated className={this.props.system_changer === 1 ? "select-btn" : "unselect-btn"} onClick={()=>this.changeSystem(1)}>
          <Button.Content visible>
            {/*<img src={md_logo} alt={"."} className={"logos"}/>&nbsp; */}
            Admin
          </Button.Content>
          <Button.Content hidden>
            {/*<img src={md_logo} alt={"."} className={"logos"}/>&nbsp;*/}
            Admin
            <Icon name='arrow down' />
          </Button.Content>
        </Button>

        {
          this.state.event_service ?
            <Button animated className={this.props.system_changer === 4 ? "select-btn" : "unselect-btn"}
                    onClick={() => this.changeSystem(4)}>
              <Button.Content visible>
                {/*<img src={ md_logo } alt={"."} className={"logos_visitor"}/>&nbsp; */}
                Event
              </Button.Content>
              <Button.Content hidden>
                {/*<img src={ md_logo } alt={"."} className={"logos_visitor"}/>&nbsp;*/}
                Event
                <Icon name='arrow down'/>
              </Button.Content>
            </Button> : null
        }

        {
          this.state.park_service ?
            <Button animated className={this.props.system_changer === 3 ? "select-btn" : "unselect-btn"}
                    onClick={() => this.changeSystem(3)}>
              <Button.Content visible>
                {/*<img src={md_logo} alt={"."} className={"logos"}/>&nbsp; */}
                Parking
              </Button.Content>
              <Button.Content hidden>
                {/*<img src={md_logo} alt={"."} className={"logos"}/>&nbsp;*/}
                Parking
                <Icon name='arrow down'/>
              </Button.Content>
            </Button> : null
        }

        {/*{*/}
        {/*  this.state.space_service ?*/}
        {/*    <Button animated className={this.props.system_changer === 5 ? "select-btn" : "unselect-btn"}*/}
        {/*            onClick={() => this.changeSystem(5)}>*/}
        {/*      <Button.Content visible>*/}
        {/*        <img src={ space_logo } alt={"."} className={"logos_visitor"}/>&nbsp; SpaceTags*/}
        {/*      </Button.Content>*/}
        {/*      <Button.Content hidden>*/}
        {/*        <img src={ space_logo } alt={"."} className={"logos_visitor"}/>&nbsp;*/}
        {/*        <Icon name='arrow down'/>*/}
        {/*      </Button.Content>*/}
        {/*    </Button> : null*/}
        {/*}*/}

        {
          this.state.visitor_service ?
            <Button animated className={this.props.system_changer === 2 ? "select-btn" : "unselect-btn"}
                    onClick={() => this.changeSystem(2)}>
              <Button.Content visible>
                {/*<img src={md_logo} alt={"."} className={"logos_visitor"}/>&nbsp; */}
                Visitor
              </Button.Content>
              <Button.Content hidden>
                {/*<img src={md_logo} alt={"."} className={"logos_visitor"}/>&nbsp;*/}
                Visitor
                <Icon name='arrow down'/>
              </Button.Content>
            </Button> : null
        }

        <Nav className="ml-auto" navbar>
          <AppHeaderDropdown direction="down">
            <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight:'10px'
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.fullName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>
              {/*<img src={usrProPic} className="img-avatar" alt="..."/>*/}
            </DropdownToggle>
            <DropdownMenu right style={{ right: 'auto' }}>
              <DropdownItem onClick={e => this.props.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
            </DropdownMenu>
          </AppHeaderDropdown>
        </Nav>
      </React.Fragment>
    );
  }
}

CorporateHeader.propTypes = propTypes;
CorporateHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  history: state.historyReducer.history,
  system_changer: state.systemChangeReducer.system_changer,
  usr_obj: state.userReducer.user,
  // dashboard count ---
  branchCount: state.COPAdminReducer.branchCount,
  departmentCount: state.COPAdminReducer.departmentCount,
  buildingsCount: state.COPAdminReducer.buildingsCount,
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CorporateHeader);
